export default {
  getAccountFromUser(user = { memberships: [] }) {
    return (
      (user.memberships &&
        user.memberships.length > 0 &&
        user.memberships[0].account) ||
      {}
    );
  },

  getMembershipFromUser(user = { memberships: [] }) {
    return (
      (user.memberships &&
        user.memberships.length > 0 &&
        user.memberships[0]) ||
      {}
    );
  },
};
